// ============================================================================
// SiFa Flow: Sentry Client Init
// ----------------------------------------------------------------------------
// DSGVO-Hard-Rules (siehe AGENTS.md Section "Observability"):
//   - sendDefaultPii: false (NIE flippen)
//   - PII-Scrubber via beforeSend / beforeBreadcrumb
//   - KEINE Session-Replay, KEIN Feedback-Widget, KEIN BrowserProfiling
//   - DSN auf EU-Region (*.ingest.de.sentry.io) — manuell in Sentry-UI wählen
// ============================================================================

import * as Sentry from "@sentry/nextjs";
import { scrubEvent, scrubBreadcrumb } from "@/lib/observability/scrubber";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    enabled: process.env.NODE_ENV === "production",
    environment: process.env.NEXT_PUBLIC_VERCEL_ENV ?? process.env.NODE_ENV,

    // Default-Integrations explizit filtern: Replay/Feedback/BrowserProfiling raus
    integrations: (defaultIntegrations) =>
      defaultIntegrations.filter(
        (i) =>
          i.name !== "Replay" &&
          i.name !== "BrowserProfiling" &&
          i.name !== "Feedback",
      ),

    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb,
  });
}
